export default {
  defaultProps: {
    // The props to change the default for.
    disableRipple: true, // No more ripple!
  },
};
